"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_UPLOAD_EVENTS = exports.FILE_STATUS = exports.PROCESSING_STATES = void 0;
var PROCESSING_STATES;
(function (PROCESSING_STATES) {
    PROCESSING_STATES[PROCESSING_STATES["INACTIVE"] = 0] = "INACTIVE";
    PROCESSING_STATES[PROCESSING_STATES["UPLOADING_IMAGES"] = 1] = "UPLOADING_IMAGES";
    PROCESSING_STATES[PROCESSING_STATES["PROCESSING_IMAGES"] = 2] = "PROCESSING_IMAGES";
})(PROCESSING_STATES = exports.PROCESSING_STATES || (exports.PROCESSING_STATES = {}));
var FILE_STATUS;
(function (FILE_STATUS) {
    FILE_STATUS[FILE_STATUS["CANCELLED"] = -999] = "CANCELLED";
    FILE_STATUS[FILE_STATUS["UPLOAD_FAILED"] = -1] = "UPLOAD_FAILED";
    FILE_STATUS[FILE_STATUS["STATIC"] = 0] = "STATIC";
    FILE_STATUS[FILE_STATUS["FILE_UPLOADED"] = 1] = "FILE_UPLOADED";
    FILE_STATUS[FILE_STATUS["FILE_PROCESSED"] = 2] = "FILE_PROCESSED";
    FILE_STATUS[FILE_STATUS["FORBIDDEN"] = 3] = "FORBIDDEN";
})(FILE_STATUS = exports.FILE_STATUS || (exports.FILE_STATUS = {}));
var FILE_UPLOAD_EVENTS;
(function (FILE_UPLOAD_EVENTS) {
    FILE_UPLOAD_EVENTS["FILES_UPLOADED"] = "$file-processor:files-uploaded";
    FILE_UPLOAD_EVENTS["IMAGE_POLLED"] = "$file-processor:file-polled";
    FILE_UPLOAD_EVENTS["PROCESSED_IMAGE"] = "$file-processor:successfully-processed-image";
    FILE_UPLOAD_EVENTS["PROCESSED_IMAGE_IDS"] = "$file-processor:successfully-processed-ids";
    FILE_UPLOAD_EVENTS["ALL_FILES_PROCESSED"] = "$file-processor:all-files-processed";
    FILE_UPLOAD_EVENTS["FILE_CANCELLED"] = "$file-processor:file-upload-cancelled";
    FILE_UPLOAD_EVENTS["FILE_UPLOADING"] = "$file-processor:file-uploading";
    FILE_UPLOAD_EVENTS["FILE_VERSION_UPDATED"] = "$file-processor:file-version-updated";
})(FILE_UPLOAD_EVENTS = exports.FILE_UPLOAD_EVENTS || (exports.FILE_UPLOAD_EVENTS = {}));
//# sourceMappingURL=uploadStateEnum.js.map